module.exports = __webpack_public_path__ + "img/btnCard-1-m.d618149f.jpg";